import {
  CustomContext,
  ResponseType,
  TRouteWithRedirect,
  useRouteContext,
} from "@sphtech/web2-core/ssr";

import AffiliateShopping from "../AffiliateShopping/AffiliateShopping";
import Category from "../Category/Category";
import { StoryPage } from "../Story/Story";

export function StoryOrSubsectionPage() {
  const routeContext: CustomContext<TRouteWithRedirect<unknown, unknown>> =
    useRouteContext();
  const { context: response } = routeContext;

  if (response.type === ResponseType.SUCCESS) {
    if (
      Object.prototype.hasOwnProperty.call(
        response.payload,
        "processedElements",
      )
    ) {
      return <StoryPage />;
    }

    if (typeof response.payload === "object" && response.payload !== null) {
      if (
        "template" in response.payload &&
        response.payload.template === "affiliateShopping"
      ) {
        return <AffiliateShopping />;
      }
    }
  }

  return <Category />;
}
